import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { Box } from '@mui/material';
import LoadingGrid from 'routes/HumanResourcesModule/components/LoadingGrid';
import { HrSimulation } from 'routes/HumanResourcesModule/Simulation/helpers/types';
import { StyNoSpacingGridContainer } from 'routes/HumanResourcesModule/components/ui/StyGridContainer';
import { useGetDetailedGradeAdvancementHypotheses } from 'routes/HumanResourcesModule/Simulation/SimulationSynthesis/Agents/components/GradeAdvancement/helpers/hooks/gradeAdvancement';
import GradeAdvancementResumeGrid from './GradeAdvancementResumeGrid';
import Accordion from 'components/SharedComponents/Accordion/Accordion';

type Props = {
    hrSimulation: HrSimulation;
};

const GradeAdvancementResume = ({
    hrSimulation,
}: Props): React.ReactElement => {
    const { t } = useTranslation();
    const { id: simulationId } = hrSimulation;
    const {
        isLoading: isGradeAdvancementResponseLoading,
        data: gradeAdvancementResponse,
    } = useGetDetailedGradeAdvancementHypotheses(simulationId);

    const gradeAdvancementHypothesesData = gradeAdvancementResponse || [];

    return (
        <Accordion
            title={t(
                'humanResources.simulation.gradeAdvancementHypothesesResume',
            )}
            defaultExpanded={false}
        >
            <Box sx={{ marginTop: '1rem' }}>
                {isGradeAdvancementResponseLoading ? (
                    <LoadingGrid />
                ) : (
                    <StyNoSpacingGridContainer>
                        <GradeAdvancementResumeGrid
                            gradeAdvancementHypotheses={
                                gradeAdvancementHypothesesData
                            }
                            hrSimulationTitle={hrSimulation.title}
                        />
                    </StyNoSpacingGridContainer>
                )}
            </Box>
        </Accordion>
    );
};

export default memo(GradeAdvancementResume);
